import { contentConstants } from "../constants"; 

interface Action {
  content: any,
  error: string,
  type: string
}

const initialState = {};

export const content = (state = initialState, action: Action) => {
  switch (action.type) {
    case contentConstants.GET_CONTENT_REQUEST:
      return {};
    case contentConstants.GET_CONTENT_SUCCESS:
      return {
        content: action.content
      };
    case contentConstants.GET_CONTENT_FAILURE:
      return {
        error: action.error
      };
    default:
      return state
  }
};